/*
 * File: useMediaQuery.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on June 4, 2025 at 5:57 PM
 * Copyright © 2025 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: June 4, 2025 at 6:43 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import {
	useEffect, useState
} from 'react';


/**
 * Hooks
 */

export default function useMediaQuery(mediaQueryString) {

	// Create state handlers
	const [matches, setMatches] = useState();

	// Handle media query changes
	useEffect(() => {
		const mediaQueryList = window.matchMedia(mediaQueryString);
		const listener = () => setMatches(!!mediaQueryList.matches);
		listener();
		mediaQueryList.addEventListener('change', listener);
		return () => mediaQueryList.removeEventListener('change', listener);
	}, [mediaQueryString]);

	// Return matches
	return matches;
}
